import PedidoItemDetPesagemService from "@/services/PedidoItemDetPesagemService";

export const pedidoItemDetPesagem = {
  namespaced: true,
  state: {
    pedidoItemDetPesagem: {},
  },
  actions: {
    getPedidoItemDetPesagem({ commit }, payload) {
      return PedidoItemDetPesagemService.GetPedidoItemDetPesagem(payload).then(
        (pedidoItemDetPesagem) => {
          return Promise.resolve(pedidoItemDetPesagem);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postPedidoItemDetPesagem({ commit }, payload) {
      return PedidoItemDetPesagemService.PostPedidoItemDetPesagem(payload).then(
        (pedidoItemDetPesagem) => {
          return Promise.resolve(pedidoItemDetPesagem);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putPedidoItemDetPesagem({ commit }, payload) {
      return PedidoItemDetPesagemService.PutPedidoItemDetPesagem(payload).then(
        (pedidoItemDetPesagem) => {
          return Promise.resolve(pedidoItemDetPesagem);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deletePedidoItemDetPesagem({ commit }, payload) {
      return PedidoItemDetPesagemService.DeletePedidoItemDetPesagem(
        payload
      ).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getPedidoItemDetPesagemOData({ commit }, payload) {
      return PedidoItemDetPesagemService.GetPedidoItemDetPesagemOData(
        payload
      ).then(
        (pedidoItemDetPesagem) => {
          return Promise.resolve(pedidoItemDetPesagem);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default pedidoItemDetPesagem;
